import React, {useState, useEffect, FC, ReactNode } from "react";
import { Helmet } from "react-helmet";
import { BrowserCssReset, GlobalStyle } from "../config";

export interface IPageContainerProps {
  title?: string;
  children: ReactNode;
};

export const PageContainer: FC<IPageContainerProps> = ({
  title = "On Pointigo",
  children,
}) => {
  
  // const [ready, setReady] = useState<boolean>(false);
  // useEffect(() => {setTimeout( () => setReady(true), 150)}, []);
  // if(!ready) return null;

  return (
    <>
    <BrowserCssReset />
    <GlobalStyle />
      <Helmet>
        <meta charSet="utf-8" />
        {/* <title>{title} v2.0.0.152</title> */}
        <link rel="canonical" href="" />
      </Helmet>
      {children}
    </>
  );
};
